/**
 * File: pbFocusWhen.js
 *
 */
(function(){
    angular
        .module('maApp.flow')
        .directive('pbFocusWhen', pbFocusWhen);

    pbFocusWhen.$inject = [];

    function pbFocusWhen(){
        return {
            link: function(scope, elm, attrs, ctrl) {

                scope.$watch(attrs['pbFocusWhen'], watch);

                function watch(newValue, oldValue){
                    if(newValue && !oldValue){
                        elm[0].focus();
                    }
                }

            }
        };
    }
})();